import { theme } from '../theme'

/**
 * Shown in place of an admin-only page's contents for a viewer.
 *
 * Explains WHY access is limited rather than showing an empty page or letting
 * the API return a bare 403 — a user who does not know roles exist would
 * otherwise read this as the tool being broken.
 */
export function AdminOnly({ what = 'This page' }: { what?: string }) {
  return (
    <div
      style={{
        background: theme.bgAlt,
        border: `1px solid ${theme.border}`,
        borderRadius: 8,
        padding: '1.5rem',
        maxWidth: 620,
      }}
    >
      <h3 style={{ margin: '0 0 0.5rem' }}>Admin access required</h3>
      <p style={{ margin: 0, fontSize: '0.88rem', color: theme.textMuted, lineHeight: 1.6 }}>
        {what} is limited to users with the admin role. You have the{' '}
        <strong style={{ color: theme.text }}>viewer</strong> role, which allows reading
        dashboards, jobs and run history but not changing configuration.
      </p>
      <p style={{ margin: '0.75rem 0 0', fontSize: '0.82rem', color: theme.textMuted }}>
        Admin is granted by group or role membership in your identity provider. If you believe you
        should have it, ask an administrator to check the role mapping on the Identity page.
      </p>
    </div>
  )
}

export default AdminOnly
